"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _ApiClient = _interopRequireDefault(require("../ApiClient"));
var _HTTPValidationError = _interopRequireDefault(require("../model/HTTPValidationError"));
var _RentalBooking = _interopRequireDefault(require("../model/RentalBooking"));
var _RentalBookingCreate = _interopRequireDefault(require("../model/RentalBookingCreate"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
 * KFV LDS API
 * Die KFV LDS API bietet eine Schnittstelle zum Backend der PWA.
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

/**
* RentalBookings service.
* @module api/RentalBookingsApi
* @version 0.0.1
*/
class RentalBookingsApi {
  /**
  * Constructs a new RentalBookingsApi. 
  * @alias module:api/RentalBookingsApi
  * @class
  * @param {module:ApiClient} [apiClient] Optional API client implementation to use,
  * default to {@link module:ApiClient#instance} if unspecified.
  */
  constructor(apiClient) {
    this.apiClient = apiClient || _ApiClient.default.instance;
  }

  /**
   * Callback function to receive the result of the createRentalBookingBookingPost operation.
   * @callback module:api/RentalBookingsApi~createRentalBookingBookingPostCallback
   * @param {String} error Error message, if any.
   * @param {module:model/RentalBooking} data The data returned by the service call.
   * @param {String} response The complete HTTP response.
   */

  /**
   * Create Rental Booking
   * @param {module:model/RentalBookingCreate} rentalBookingCreate 
   * @param {module:api/RentalBookingsApi~createRentalBookingBookingPostCallback} callback The callback function, accepting three arguments: error, data, response
   * data is of type: {@link module:model/RentalBooking}
   */
  createRentalBookingBookingPost(rentalBookingCreate, callback) {
    let postBody = rentalBookingCreate;
    // verify the required parameter 'rentalBookingCreate' is set
    if (rentalBookingCreate === undefined || rentalBookingCreate === null) {
      throw new Error("Missing the required parameter 'rentalBookingCreate' when calling createRentalBookingBookingPost");
    }
    let pathParams = {};
    let queryParams = {};
    let headerParams = {};
    let formParams = {};
    let authNames = ['JWTBearer'];
    let contentTypes = ['application/json'];
    let accepts = ['application/json'];
    let returnType = _RentalBooking.default;
    return this.apiClient.callApi('/booking/', 'POST', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null, callback);
  }

  /**
   * Callback function to receive the result of the deleteRentalBookingBookingBookingIdDelete operation.
   * @callback module:api/RentalBookingsApi~deleteRentalBookingBookingBookingIdDeleteCallback
   * @param {String} error Error message, if any.
   * @param {Object} data The data returned by the service call.
   * @param {String} response The complete HTTP response.
   */

  /**
   * Delete Rental Booking
   * @param {Number} bookingId 
   * @param {module:api/RentalBookingsApi~deleteRentalBookingBookingBookingIdDeleteCallback} callback The callback function, accepting three arguments: error, data, response
   * data is of type: {@link Object}
   */
  deleteRentalBookingBookingBookingIdDelete(bookingId, callback) {
    let postBody = null;
    // verify the required parameter 'bookingId' is set
    if (bookingId === undefined || bookingId === null) {
      throw new Error("Missing the required parameter 'bookingId' when calling deleteRentalBookingBookingBookingIdDelete");
    }
    let pathParams = {
      'booking_id': bookingId
    };
    let queryParams = {};
    let headerParams = {};
    let formParams = {};
    let authNames = ['JWTBearer'];
    let contentTypes = [];
    let accepts = ['application/json'];
    let returnType = Object;
    return this.apiClient.callApi('/booking/{booking_id}', 'DELETE', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null, callback);
  }

  /**
   * Callback function to receive the result of the getRentalBookingBookingBookingIdGet operation.
   * @callback module:api/RentalBookingsApi~getRentalBookingBookingBookingIdGetCallback
   * @param {String} error Error message, if any.
   * @param {module:model/RentalBooking} data The data returned by the service call.
   * @param {String} response The complete HTTP response.
   */

  /**
   * Get Rental Booking
   * @param {Number} bookingId 
   * @param {module:api/RentalBookingsApi~getRentalBookingBookingBookingIdGetCallback} callback The callback function, accepting three arguments: error, data, response
   * data is of type: {@link module:model/RentalBooking}
   */
  getRentalBookingBookingBookingIdGet(bookingId, callback) {
    let postBody = null;
    // verify the required parameter 'bookingId' is set
    if (bookingId === undefined || bookingId === null) {
      throw new Error("Missing the required parameter 'bookingId' when calling getRentalBookingBookingBookingIdGet");
    }
    let pathParams = {
      'booking_id': bookingId
    };
    let queryParams = {};
    let headerParams = {};
    let formParams = {};
    let authNames = [];
    let contentTypes = [];
    let accepts = ['application/json'];
    let returnType = _RentalBooking.default;
    return this.apiClient.callApi('/booking/{booking_id}', 'GET', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null, callback);
  }

  /**
   * Callback function to receive the result of the getRentalBookingsBookingGet operation.
   * @callback module:api/RentalBookingsApi~getRentalBookingsBookingGetCallback
   * @param {String} error Error message, if any.
   * @param {Array.<module:model/RentalBooking>} data The data returned by the service call.
   * @param {String} response The complete HTTP response.
   */

  /**
   * Get Rental Bookings
   * @param {String} status 
   * @param {Boolean} archived 
   * @param {module:api/RentalBookingsApi~getRentalBookingsBookingGetCallback} callback The callback function, accepting three arguments: error, data, response
   * data is of type: {@link Array.<module:model/RentalBooking>}
   */
  getRentalBookingsBookingGet(status, archived, callback) {
    let postBody = null;
    // verify the required parameter 'status' is set
    if (status === undefined || status === null) {
      throw new Error("Missing the required parameter 'status' when calling getRentalBookingsBookingGet");
    }
    // verify the required parameter 'archived' is set
    if (archived === undefined || archived === null) {
      throw new Error("Missing the required parameter 'archived' when calling getRentalBookingsBookingGet");
    }
    let pathParams = {};
    let queryParams = {
      'status': status,
      'archived': archived
    };
    let headerParams = {};
    let formParams = {};
    let authNames = ['JWTBearer'];
    let contentTypes = [];
    let accepts = ['application/json'];
    let returnType = [_RentalBooking.default];
    return this.apiClient.callApi('/booking/', 'GET', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null, callback);
  }

  /**
   * Callback function to receive the result of the stornoRentalBookingBookingBookingIdStornoPut operation.
   * @callback module:api/RentalBookingsApi~stornoRentalBookingBookingBookingIdStornoPutCallback
   * @param {String} error Error message, if any.
   * @param {module:model/RentalBooking} data The data returned by the service call.
   * @param {String} response The complete HTTP response.
   */

  /**
   * Storno Rental Booking
   * @param {Number} bookingId 
   * @param {module:api/RentalBookingsApi~stornoRentalBookingBookingBookingIdStornoPutCallback} callback The callback function, accepting three arguments: error, data, response
   * data is of type: {@link module:model/RentalBooking}
   */
  stornoRentalBookingBookingBookingIdStornoPut(bookingId, callback) {
    let postBody = null;
    // verify the required parameter 'bookingId' is set
    if (bookingId === undefined || bookingId === null) {
      throw new Error("Missing the required parameter 'bookingId' when calling stornoRentalBookingBookingBookingIdStornoPut");
    }
    let pathParams = {
      'booking_id': bookingId
    };
    let queryParams = {};
    let headerParams = {};
    let formParams = {};
    let authNames = ['JWTBearer'];
    let contentTypes = [];
    let accepts = ['application/json'];
    let returnType = _RentalBooking.default;
    return this.apiClient.callApi('/booking/{booking_id}/storno', 'PUT', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null, callback);
  }

  /**
   * Callback function to receive the result of the updateRentalBookingBookingBookingIdPut operation.
   * @callback module:api/RentalBookingsApi~updateRentalBookingBookingBookingIdPutCallback
   * @param {String} error Error message, if any.
   * @param {module:model/RentalBooking} data The data returned by the service call.
   * @param {String} response The complete HTTP response.
   */

  /**
   * Update Rental Booking
   * @param {Number} bookingId 
   * @param {module:model/RentalBooking} rentalBooking 
   * @param {module:api/RentalBookingsApi~updateRentalBookingBookingBookingIdPutCallback} callback The callback function, accepting three arguments: error, data, response
   * data is of type: {@link module:model/RentalBooking}
   */
  updateRentalBookingBookingBookingIdPut(bookingId, rentalBooking, callback) {
    let postBody = rentalBooking;
    // verify the required parameter 'bookingId' is set
    if (bookingId === undefined || bookingId === null) {
      throw new Error("Missing the required parameter 'bookingId' when calling updateRentalBookingBookingBookingIdPut");
    }
    // verify the required parameter 'rentalBooking' is set
    if (rentalBooking === undefined || rentalBooking === null) {
      throw new Error("Missing the required parameter 'rentalBooking' when calling updateRentalBookingBookingBookingIdPut");
    }
    let pathParams = {
      'booking_id': bookingId
    };
    let queryParams = {};
    let headerParams = {};
    let formParams = {};
    let authNames = ['JWTBearer'];
    let contentTypes = ['application/json'];
    let accepts = ['application/json'];
    let returnType = _RentalBooking.default;
    return this.apiClient.callApi('/booking/{booking_id}', 'PUT', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null, callback);
  }
}
exports.default = RentalBookingsApi;